export const BUSINESS_NAME_VALIDATION_REGEX = /([<>="`!?%~${}\\])/;
export const BUSINESS_NAME_VALIDATION_REGEX_HIGHLIGHTER = new RegExp(BUSINESS_NAME_VALIDATION_REGEX, 'g');
